<template>
  <div class="markdown-view" v-html="rendered"></div>
</template>
<script>
import { marked } from 'marked'
import hljs from 'highlight.js'
// 代码高亮主题
import 'highlight.js/styles/github.css'
// 数学公式（题面中常见 $...$ 与 $$...$$）
import katex from 'katex'
import 'katex/dist/katex.min.css'

export default {
  name: 'MarkdownView',
  props: {
    // Markdown 原文
    content: { type: String, default: '' }
  },
  computed: {
    rendered() {
      if (!this.content) {
        return ''
      }
      return this.renderMarkdown(this.content)
    }
  },
  methods: {
    renderMarkdown(text) {
      let html = ''
      try {
        if (marked.setOptions) {
          marked.setOptions({
            breaks: true,
            gfm: true,
            highlight(code, lang) {
              if (lang && hljs.getLanguage(lang)) {
                try {
                  return hljs.highlight(code, { language: lang }).value
                } catch (e) {
                  // 忽略高亮失败，退回原样输出
                }
              }
              return hljs.highlightAuto(code).value
            }
          })
        }
        html = typeof marked === 'function' ? marked(text) : marked.parse(text)
      } catch (e) {
        // 渲染失败时按纯文本展示，避免整块内容消失
        return this.escapeHtml(text)
      }
      return this.renderKatex(html)
    },
    // 渲染 $...$ 与 $$...$$ 数学公式
    renderKatex(html) {
      try {
        // 块级公式
        html = html.replace(/\$\$([\s\S]+?)\$\$/g, (match, expr) => {
          try {
            return katex.renderToString(expr, { displayMode: true, throwOnError: false })
          } catch (e) {
            return match
          }
        })
        // 行内公式
        html = html.replace(/\$([^\$\n]+?)\$/g, (match, expr) => {
          try {
            return katex.renderToString(expr, { displayMode: false, throwOnError: false })
          } catch (e) {
            return match
          }
        })
      } catch (e) {
        // 公式渲染失败不影响正文
      }
      return html
    },
    escapeHtml(text) {
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\n/g, '<br/>')
    }
  }
}
</script>
<style scoped>
.markdown-view {
  font-size: 14px;
  line-height: 1.8;
  color: #303133;
  word-break: break-word;
}
.markdown-view >>> p {
  margin: 0 0 12px 0;
}
.markdown-view >>> h1,
.markdown-view >>> h2,
.markdown-view >>> h3,
.markdown-view >>> h4 {
  margin: 18px 0 12px 0;
  font-weight: 600;
  color: #303133;
}
.markdown-view >>> ul,
.markdown-view >>> ol {
  padding-left: 24px;
  margin: 0 0 12px 0;
}
.markdown-view >>> li {
  margin-bottom: 6px;
}
.markdown-view >>> code {
  background-color: #f5f7fa;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: Consolas, Monaco, "Courier New", monospace;
  font-size: 13px;
  color: #c7254e;
}
.markdown-view >>> pre {
  background-color: #f6f8fa;
  padding: 12px 16px;
  border-radius: 6px;
  overflow-x: auto;
  margin: 0 0 12px 0;
}
.markdown-view >>> pre code {
  background-color: transparent;
  padding: 0;
  color: #24292e;
}
.markdown-view >>> blockquote {
  margin: 0 0 12px 0;
  padding: 8px 16px;
  border-left: 4px solid #dcdfe6;
  background-color: #fafafa;
  color: #606266;
}
.markdown-view >>> table {
  border-collapse: collapse;
  margin: 0 0 12px 0;
  width: 100%;
}
.markdown-view >>> table th,
.markdown-view >>> table td {
  border: 1px solid #ebeef5;
  padding: 8px 12px;
  text-align: left;
}
.markdown-view >>> table th {
  background-color: #f5f7fa;
  font-weight: 600;
}
.markdown-view >>> img {
  max-width: 100%;
}
</style>
